(ns hai.web-app.platform
  (:require
   [clojure.string :as str]))

(goog-define ORIGIN "")

(def mac?
  "True when running on a Mac/iOS device — for picking ⌘ vs Ctrl in shortcuts."
  (boolean (and (exists? js/navigator)
                (re-find #"(?i)mac|iphone|ipad" (or (.-platform js/navigator) "")))))

(defn submit-shortcut?
  "True for the platform's submit chord (⌘/Ctrl + Enter)."
  [e]
  (and (= "Enter" (.-key e))
       (or (.-metaKey e) (.-ctrlKey e))))

(defn url [& parts]
  (str
   ORIGIN
   (when (and (first parts) (not= \/ (ffirst parts)))
     "/")
   (str/join "/" parts)))
